import { render, staticRenderFns } from "./clientEnd.vue?vue&type=template&id=2aebe990&scoped=true&"
import script from "./clientEnd.vue?vue&type=script&lang=ts&"
export * from "./clientEnd.vue?vue&type=script&lang=ts&"
import style0 from "./clientEnd.vue?vue&type=style&index=0&id=2aebe990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aebe990",
  null
  
)

export default component.exports